import store from "../../../store";
import delivero_export from './delivero_export.vue';

window.delivero_export =  new Vue({
    store,
    el: 'div#delivero_export',
    name : "delivero_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        delivero_export,
    }
});
